import React from "react";
import "./StageCard.scss";

// Components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IonButton } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import CardInner from "../CardInner/CardInner";
import RequestsCardInner from "../RequestsCardInner/RequestsCardInner";

// Utils
import { faArrowRight } from "@fortawesome/pro-light-svg-icons";
import IconButton from "../../../../components/Button/Icon/IconButton";
import { useViewport } from "../../../../utils/useViewport";

interface Props {
  stage: any;
  key: number;
  loading: boolean;
}

export default function StagesCard({ stage, loading }: Props) {
  const { isDesktop } = useViewport();
  const { t } = useTranslation();
  return (
    <div className={["registration-stages__column", stage.active ? "registration-stages__column--active" : null].filter(Boolean).join(" ")}>
      <div className="registration-stages__column__inner">
        <div className="registration-stages__column__header">
          {Array.isArray(stage.icon) ? (
            <span className="fa-layers fa-fw ion-float-start">
              <FontAwesomeIcon icon={stage.icon[1]} color={stage.iconColour} />
              <FontAwesomeIcon icon={stage.icon[0]} inverse transform="shrink-6" />
            </span>
          ) : (
            <FontAwesomeIcon icon={["far", stage.icon]} color={stage.iconColour} className="fa-fw ion-float-start" />
          )}
          <span className="display--block overflow--hidden registration-stages__column__header__label">
            {stage.name}
            <span>{`(${stage.users.length && stage.users.length})`}</span>
          </span>
          <IconButton icon={faArrowRight} routerLink={`/admin/members?${new URLSearchParams(stage.viewAllParams)}`} tooltip="See All" align="left" />
        </div>
        {stage.viewAllParams["filters[pending_revisions]"] && isDesktop ? <RequestsCardInner stage={stage} loading={loading} /> : <CardInner stage={stage} loading={loading} />}
        {
          <Link
            className="registration-stages__column__header__see-all registration-stages__column__header__see-all--mobile ion-hide-md-up"
            to={`/admin/members?${new URLSearchParams(stage.viewAllParams)}`}
          >
            <IonButton fill="outline" expand="block" color={stage.active ? "light" : "dark"}>
              {t("seeAll")}
            </IonButton>
          </Link>
        }
      </div>
    </div>
  );
}
